import React from 'react';
import { assets } from '../data/landing';
type AppPromoImageProps = {
  priority?: boolean;
};

/**
 * Official "Así es la app por dentro" asset.
 * Rendered edge to edge, unmodified: no card, no frame, no mockup, no crop.
 */
export function AppPromoImage({
  priority = false
}: AppPromoImageProps) {
  return <img src={assets.appPromo} alt="Tres pantallas de la app Pawsy Emprende: tu camino en Pawsy, lo esencial para trabajar con mascotas y el panel de tu negocio" loading={priority ? 'eager' : 'lazy'} decoding="async" className="block h-auto w-full select-none" data-id="element-15" data-mp="apsiq11fd4ur" />;
}